import gql from 'graphql-tag'

export const ALL_USERS = gql`
query {
  allUsers {
    edges {
      node {
        username
        email
        role
        id
      }
    }
  }
}
`

export const DELETE_USER = gql`
  mutation ($id: Int!){
    deleteUserById(
      input: {
        id: $id
      }
    ) {
      deletedUserId
      user {
        username
      }
    }
  }
  `

export const USER_BY_EMAIL = gql`
  query ($email: String!){
    userByEmail(email: $email){
      id
      email
      salt
      hash
      role
    }
  }`

export const USERS_GET_USER_BY_EMAIL = gql`
  query ($email: String!){
    usersGetUserByEmail(input: {
      email: $email
    }) 
    {
      edges {
        node {
          email
          id
          salt
          hash
          role
        }
      }
    }
  }`

export const USER_GET_ID_BY_NAME = gql`
  mutation ($username: String!) {
    usersGetId(input: {
      username: $username
    }) {
      clientMutationId
      integer 
    }
  }`

export const USER_CREATE = gql`
  mutation ($email: String!, $hash: String!, $salt: String!, $role: String){
    createUser(input:{
      user:{
        email: $email
        hash: $hash
        salt: $salt
        role: $role
      }
    }){
      userEdge{
        node{
          id
          email
        }
      }
    }
  }
  `
// a remplacement for USER_CREATE with encryption done in pg
export const USER_REGISTER = gql`
mutation($email: String!, 
  $password: String!, $role: String!){
  register(input: {
    email: $email
    password: $password
    role: $role
  }){
    integer
  }
}
`
export const USER_BY_ID_SIMPLE = gql`
  query ($id: Int!){
    userById(id: $id){
      id
      email
      username
      role
  }
}`



// WEBPACK FOOTER //
// ./src/constants/user.js